module.exports = "https://cwa.roocdn.com/_next/static/social_media.2a6fac33.png";